import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    accountHolder: 'Account holder',
    bic: 'BIC',
    bicIntermediary: 'Intermediary SWIFT BIC',
    copyAll: 'Copy all',
    iban: 'IBAN',
    internationalTransfer: 'International transfer',
    itemCopied: 'Your {item} has been copied to your clipboard.',
    rib: 'Download my RIB',
    swiftBIC: 'TRWIBEB3',
    swiftDetails:
      'To receive a transfer through the Swift network, you may be asked to provide the following BIC of our partner bank Wise: ',
  },
  fr: {
    accountHolder: 'Titulaire du compte',
    bic: 'BIC',
    bicIntermediary: 'BIC intermédiaire SWIFT',
    copyAll: 'Copier l’ensemble',
    iban: 'IBAN',
    internationalTransfer: 'Virement international',
    itemCopied: 'Votre {item} a été copié dans votre presse-papier.',
    rib: 'Télécharger mon RIB',
    swiftBIC: 'TRWIBEB3',
    swiftDetails:
      'Pour recevoir un virement utilisant le réseau Swift, le BIC de notre banque partenaire Wise peut vous être demandé : ',
  },
} as const);

export default locales;
